import React from 'react';
import './css/GiveawayTable.css'; // Создадим этот CSS файл для стилей
import { t } from 'ttag';

function GiveawayTable({ data, pround }) {
    return (
        <div className="giveaway-table-container">
            <table className="giveaway-table">
                <thead>
                    <tr>
                        <th style={{ minWidth: "5em" }}>{t`Date`}</th>
                        <th>№</th>
                        <th>{t`Ticket`}</th>
                        <th>{t`Winner`}</th>

                    </tr>
                </thead>
                <tbody>
                    <tr key="0">
                        <td className='pending'>{t`pending`}</td>
                        <td>{pround}</td>
                        <td className='pending' >{t`pending`}</td>
                        <td className='pending'>{t`pending`}</td>

                    </tr>
                    {data.map((row, index) => (
                        <tr key={index}>
                            <td>{row.dt}</td>
                            <td>{row.round}</td>
                            <td>{row.ticket}</td>
                            <td>{row.tgName}</td>

                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default GiveawayTable;